export default "__VITE_ASSET__Qtakj413__"